import React, { memo } from 'react';
import PropTypes from 'prop-types';
import EmptyView from "./components/EmptyView";
import ErrorView from "./components/ErrorView";
import LoadingOverlay from "./LoadingOverlay";
var _ref2 = /*#__PURE__*/React.createElement(LoadingOverlay, null);
const NoRowsOverlay = /*#__PURE__*/memo(_ref => {
  let {
    isLoading,
    hasError,
    emptyViewProps,
    errorViewProps,
    customEmptyViewComponent
  } = _ref;
  if (isLoading) return _ref2;
  let finalErrorViewProps;
  let finalEmptyViewProps;
  if (typeof errorViewProps === 'function') finalErrorViewProps = errorViewProps();else finalErrorViewProps = errorViewProps;
  if (typeof emptyViewProps === 'function') finalEmptyViewProps = emptyViewProps();else finalEmptyViewProps = emptyViewProps;
  return hasError ? /*#__PURE__*/React.createElement(ErrorView, finalErrorViewProps) : /*#__PURE__*/React.createElement(EmptyView, finalEmptyViewProps);
});
process.env.NODE_ENV !== "production" ? NoRowsOverlay.propTypes = {
  errorViewProps: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string
  })]),
  emptyViewProps: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    icon: PropTypes.node,
    title: PropTypes.string,
    subtitle: PropTypes.string
  })])
} : void 0;
export default NoRowsOverlay;